




















import { computed, defineComponent } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import { getElement } from "@/lib/elementHelpers";
import ContentFeedCover from "@/components/ContentFeedCover";
import InfiniteScroll from "@/components/InfiniteScroll";

export default defineComponent({
  name: "ContentFeedGrid",
  components: { InfiniteScroll, ContentFeedCover },
  props: {
    contentFeedList: { type: Array as () => ContentFeed[], required: true },
    feedId: { type: String },
    enableScroll: { type: Boolean, default: true },
    enablePinPost: { type: Boolean, default: true },
    showPinnedOnDiscover: { type: Boolean, default: false },
  },
  setup() {
    const { authUser } = useAuthUser();
    const { showNotSafeForWork } = useNSFWUserSettings();

    const authUserId = computed(() => authUser.value?.id ?? "");
    return { authUserId, showNotSafeForWork };
  },
  watch: {
    feedId(feedIdNew?: string, feedIdOld?: string) {
      setTimeout(() => {
        if (feedIdOld && !feedIdNew) {
          const selectedIndex = this.contentFeedList.findIndex(i => i.id === feedIdOld);
          getElement<HTMLElement>(this.$refs.feeds, selectedIndex).scrollIntoView({
            block: "center",
            behavior: "auto",
          });
        }
      }, 0);
    },
  },
});
